import styled from 'styled-components'
import colorsOptions from '../../../../components/stories/fundamentals/colors-styles/constants.js'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../components/stories/fundamentals/text-styles/constants.js'
import { motion } from 'framer-motion'

export const SsoContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${colorsOptions.greys['grey-10']};
  @media (max-width: 768px) {
    justify-content: flex-start;
    padding: 0 16px 16px 16px;
  }
`

export const SsoSelectionTitle = styled.span`
  padding: 1rem 1rem 0.5rem 1rem;
  color: ${colorsOptions.greys['grey-90']};

  /* 700 (bold)/700-XL */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
`

export const SsoItemsContainer = styled.div`
  margin: 38px 0;
  display: grid;
  max-width: 565px;
  gap: 2rem;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 767px) {
    margin: 16px 0;
    grid-template-rows: repeat(2, minmax(0, 1fr));
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }
`

// item

export const SsoItemContainer = styled.a`
  width: 100%;
  max-width: 167px;
  min-height: 167px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  text-decoration: none;
  background: ${colorsOptions.greys.white};
  padding: 0.5rem;

  box-shadow:
    0px 34px 10px 0px rgba(20, 26, 33, 0),
    0px 22px 9px 0px rgba(20, 26, 33, 0),
    0px 12px 7px 0px rgba(20, 26, 33, 0.01),
    0px 6px 6px 0px rgba(20, 26, 33, 0.02),
    0px 1px 3px 0px rgba(20, 26, 33, 0.02);

  &:active {
    background: ${colorsOptions.greys['grey-20']};
  }

  @media (max-width: 768px) {
    max-width: 175px;
    min-height: 175px;
  }
`

export const SsoItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: scale-down;
`

export const SsoSpinerContainer = styled.div`
  display: flex;
  height: 100%;
  width: 151px;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 159px;
  }
`

export const SsoItemTitleContainer = styled.div`
  height: 40px;
  color: ${colorsOptions.greys['grey-70']};
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  /* 600 (semibold)/600-S */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]}
`

// Skeleton
export const Skeleton = motion(styled(SsoItemContainer)`
  width: 167px;
  @media (max-width: 768px) {
    width: 175px;
  }
`)

// MobileHeader
export const MobileHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 50px;
  position: relative;
  justify-content: flex-start;
`

export const SsoMobileSelectionTitle = styled.div`
  color: ${colorsOptions.greys['grey-100']};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  text-align: center;

  /* 700 (bold)/700-XL */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
`

export const SsoMobileBackButton = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${colorsOptions.greys['grey-100']};

  /* 600 (bold)/600-L */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
`
